<template>
  <div class="printQRCodeList">
    <el-card>
      <el-table :data="tabelData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" :height="tabelData.length > 0? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
        type="index"
        :index="indexMethod" align="center"
        :label="$t('lang.lab_index')"
        width="100px"></el-table-column>
        <!-- 平面图 -->
        <el-table-column prop="planarGraphName" :label="$t('lang.lab_Plan')"></el-table-column>
        <!-- 类型 -->
        <el-table-column :label="$t('lang.lab_Type')" prop="patrolTypeName"></el-table-column>
        <!-- 数量 -->
        <el-table-column :label="$t('lang.lab_Count')" prop="pCount"></el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width6">
          <template slot-scope="scope">
            <!-- 点位下载 -->
            <el-button @click="downPoint(scope.row.planarGraphId, scope.row.patrolTypeId)">{{$t('lang.btn_pointDown')}}</el-button>
            <!-- 点位地图下载 -->
            <el-button class="orange" @click="jumpPoint(scope.row.planarGraphId, scope.row.patrolTypeId)">{{$t('lang.btn_pointMapDown')}}</el-button>
            <!-- 点位顺序设置 -->
            <el-button @click="pointSequenceSetting(scope.row.planarGraphId, scope.row.patrolTypeId)">{{$t('lang.btn_pointSequenceSetting')}}</el-button>
            <!-- 巡检路线设置 -->
            <el-button @click="InspectionLineSetting(scope.row.planarGraphId, scope.row.patrolTypeId)" class="orange">{{$t('lang.btn_patrolRouteSettings')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
        />
    </el-card>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      @closed="handleDialogClosed">
      <el-carousel arrow="always" :autoplay="false" indicator-position="none">
        <el-carousel-item v-for="item in pointArray" v-bind:key="item.pointId">
          <vue-qr :text="item.pointId + ''" :title="'点位名称：' + item.pointId" :size="250"></vue-qr>
          <div class="pointLeft">{{$t('lang.lab_PL_pointNameShow') + item.msg}}</div>
        <!-- 二维码小插件,  npm install vue-qr --save  参考文章https://blog.csdn.net/qq_24209163/article/details/83086059 -->
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:printQRCodeList
 *@Description:打印二维码列表/点位下载
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-16
 */
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      show: false, // 二维码弹框显示
      pageCount: 0, // 总页数
      multipleSelection: [], // 多选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      PlanarGraphId: '', // 巡检类型ID
      PatrolTypeId: '', // 平面图ID
      tabelData: [], // 打印二维码的列表
      pointArray: [], // 点位下载的列表
      dialogTitle: this.$i18n.t('lang.lab_pointQRCodeDown'),
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
    }
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.list()
    }
  },
  created() {
    this.list()
  },
  methods: {
    // 监听关闭dialog
    handleDialogClosed() {

    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // checkbox
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 二维码列表
    list() {
      let loading = this.$loading()
      this.$get(
        `/patrolPoint?GardenId=${this.gardenId}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tabelData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
      this.list()
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.list()
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 点位下载
    downPoint(planarGraphId, patrolTypeId) {
      this.show = true
      let loading = this.$loading()
      this.$get(
        `/patrolPointList?GardenId=${this.gardenId}&PlanarGraphId=${planarGraphId}&PatrolTypeId=${patrolTypeId}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.pointArray = res.pointJsonArray
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点位地图下载后直接跳转到平面图点位设置里面
    jumpPoint(planarGraphId, patrolTypeId) {
      this.$router.push({ name: 'pointSetting', query: { id: planarGraphId, typeId: patrolTypeId } })
    },
    // 点位顺序设置跳转新页面
    pointSequenceSetting(planarGraphId, patrolTypeId) {
      this.$router.push({ name: 'pointOrderSetting', query: { id: planarGraphId, typeId: patrolTypeId } })
    },
    // 巡检路线设定跳转
    InspectionLineSetting(planarGraphId, patrolTypeId) {
      this.$router.push({ name: 'InspectionLineSetting', query: { id: planarGraphId, typeId: patrolTypeId } })
    }
  }
}
</script>

<style lang="scss">
.pointLeft {
  font-size: 20px;
}
.el-carousel__container {
  text-align: center;
}
</style>